module.exports = __webpack_public_path__ + "static/video9-4856eb8f2c8a0126513ba17985dab62c.mp4";